import React, { useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useRouteMatch } from "react-router-dom";

import {
  MenuLogo,
  HeaderNav,
  HeaderMeta,
  HeaderBrand,
  StyledHeader
} from "./styles";
import UserMenu from "./UserMenu";
import HelpMenu from "./HelpMenu";
import DraftMenu from "./DraftMenu";
import { TooltipInfo } from "./styles";
import IconButton from "../common/IconButton";
import MainNavigation from "./MainNavigation";
import CreateAiAnnouncement from "./CreateAiAnnouncement";
import { Menu } from "styled-icons/feather";
import { PlusIcon } from "./icons";
import { useAppState } from "contextApi/appContext";
import { StickyBanner } from "components/common/styles";
import logo from "assets/images/willow-text-color@2x.png";
import { useComposerActions } from "contextApi/composerContext";
import { trackAnalyticsEvent } from "state/actions/AnalyticsActions";
import { Tool } from "styled-icons/feather";
import { theme } from "theme";

const MainHeader = React.memo(() => {
  const dispatch = useDispatch();
  const account = useSelector(state => state.account.data);
  const history = useHistory();
  const match = useRouteMatch({
    path: "*/dashboard",
    exact: false
  });
  const [isExpanded, setExpanded] = useState(false);
  const windowSize = useAppState(state => state.windowSize);
  // const ldError = useAppState(state => state.ldError);  --- use this to avoid showing a dark feature if LaunchDarkly returns an error
  // const showWillowAIRevamp = useAppState(state => state.showWillowAIRevamp); --- example feature flag from LaunchDarkly - example on line 96

  // Auto-hide maintenance banner after end date (local time interpreted with offset)
  const MAINTENANCE_END_ISO = "2025-10-14T06:00:00+02:00"; // Oct 14, 2025 06:00 CEST
  const [showMaintenanceBanner, setShowMaintenanceBanner] = useState(() => new Date() < new Date(MAINTENANCE_END_ISO));

  const openComposer = useComposerActions(actions => actions.openComposer);

  const handleNavClick = useCallback(() => {
    if (windowSize === "xsmall") {
      setExpanded(false);
    }
  }, [windowSize]);

  const toggleMenu = useCallback(() => {
    setExpanded(isExpanded => !isExpanded);
  }, []);

  const openComposerModal = useCallback(() => {
    openComposer();
  }, [openComposer]);

  return (
    <StyledHeader>
      <div className="main">
        <HeaderBrand>
          <Link to={`/accounts/${account.id}/dashboard`}>
            <MenuLogo src={logo} />
          </Link>
        </HeaderBrand>
        <HeaderNav>
          {(windowSize !== "xsmall" || isExpanded) && (
            <MainNavigation
              accountId={account.id}
              wasClicked={handleNavClick}
            />
          )}
        </HeaderNav>
        <HeaderMeta>
          {windowSize === "xsmall" && (
            <IconButton
              icon={Menu}
              onClick={toggleMenu}
              variant={isExpanded ? "primary" : "secondary"}
            />
          )}
          <IconButton
            data-tip={"New Post"}
            id={"headerNewPostButton"}
            variant="green"
            icon={PlusIcon}
            onClick={openComposerModal}
            size={36}
          />
          <TooltipInfo effect={"solid"} place={"bottom"} />

          <DraftMenu />
          <HelpMenu account={account} />
          <UserMenu account={account} />
        </HeaderMeta>
      </div>
      {/* Example on how to use LaunchDarkly feature flag for announcement banner: */}
      {/* {!ldError && showWillowAIRevamp && ( */}
      <StickyBanner $isVisible={!!match && showMaintenanceBanner}>
        <p>
          <em>
            <Tool size={20} color={theme.colors.text03} />
            The Willow platform will be unavailable for maintenance from Monday, October 13, 9:00 PM to Tuesday, October 14, 6:00 AM CEST.
          </em>
        </p>
        <i
          className="icon-cancel"
          onClick={() => setShowMaintenanceBanner(false)}
        />
      </StickyBanner>
      <CreateAiAnnouncement />
    </StyledHeader>
  );
});

export default MainHeader;
